import { Flex, Text } from "@mantine/core";
import type { JSX } from "react";
import { useVerifiedCustomerStore } from "@/customer-info";
import { useSessionId } from "@/sdk";
import { ShieldIcon } from "./ShieldIcon";
import { getDurationText } from "./utils";

export function CustomerPlanInfo(): JSX.Element {
    const sessionId = useSessionId();
    const customer = useVerifiedCustomerStore((state) => state.getVerifiedCustomer(sessionId).customer);

    let lengthOfTime: string | undefined;
    if (customer?.purchaseDate) {
        lengthOfTime = getDurationText(customer.purchaseDate, new Date());
    }
    return (
        <Flex gap="3xs" w="max-content">
            <Text c="dark.2" size="xxs" pr="3xs">
                {`Protected for ${lengthOfTime}`}
            </Text>
            <ShieldIcon />
        </Flex>
    );
}
